import React, { Component } from 'react';
import bus from './bus';
import Ajax from './ajax';

class Edit extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.onChargeChange = this.onChargeChange.bind(this);
        this.setValue = this.setValue.bind(this);
        this.remove = this.remove.bind(this);
        this.back = this.back.bind(this);
    }

    componentDidMount() {
        Ajax.post('get', { id: this.props.id }, function (response) {
            this.toast.style.display = 'none';
            if (response.result) {
                this.setValue(response.data);
            }
        }.bind(this));
    }

    componentWillUnmount() {
    }

    onChargeChange() {
        let value = this.charge.value;
        this.chargeForm1.style.display = value == 1 ? 'flex' : 'none';
        this.chargeForm2.style.display = value == 2 ? 'flex' : 'none';
    }

    setValue(data) {
        this.id.value = data.id;
        this.oldName = data.name;
        this.name.value = data.name;
        this.total.value = data.total;
        this.status.value = data.status;
        this.charge.value = data.charge;
        this.onChargeChange();
        this.expired.value = data.expired;
        this.remain.value = data.remain;
    }

    remove() {
        Ajax.post('remove', { id: this.id.value, name: this.oldName }, function (response) {
            if (response.result) {
                bus.emit('result', response);
            }
        });
    }

    back() {
        bus.emit('view', '#manager');
    }

    submit(event) {
        event.preventDefault();
        let value = this.charge.value;
        if (value == 1) {
            if (this.expired.value.length < 1) {
                alert('请选择到期时间');
                return;
            }
        } else if (value == 2) {
            if (this.remain.value.length < 1) {
                alert('请输入通知条数');
                return;
            }
        }
        let data = { id: this.id.value, name: this.name.value, status: this.status.value, charge: this.charge.value, expired: this.expired.value, remain: this.remain.value };
        Ajax.post('edit', data, function (response) {
            if (response.result) {
                bus.emit('result', response);
            }
        });
    }

    render() {
        return (
            <div>
                <form onSubmit={this.submit}>
                    <div className="weui-cells weui-cells_form">
                        <div className="weui-cell">
                            <div className="weui-cell__hd"><label className="weui-label" htmlFor="id">ID</label></div>
                            <div className="weui-cell__bd">
                                <input id="id" ref={id => this.id = id} className="weui-input" type="text" readOnly="readOnly" />
                            </div>
                        </div>
                        <div className="weui-cell">
                            <div className="weui-cell__hd"><label className="weui-label" htmlFor="name">项目名称</label></div>
                            <div className="weui-cell__bd">
                                <input id="name" ref={name => this.name = name} className="weui-input" type="text" required placeholder="请输入项目名称" />
                            </div>
                        </div>
                        <div className="weui-cell">
                            <div className="weui-cell__hd"><label className="weui-label" htmlFor="total">调用总数</label></div>
                            <div className="weui-cell__bd">
                                <input id="total" ref={total => this.total = total} className="weui-input" type="text" readOnly="readOnly" />
                            </div>
                        </div>
                        <div className="weui-cell weui-cell_select weui-cell_select-after">
                            <div className="weui-cell__hd">
                                <label className="weui-label" htmlFor="status">状态</label>
                            </div>
                            <div className="weui-cell__bd">
                                <select className="weui-select" id="status" ref={status => this.status = status}>
                                    <option value="0">禁用</option>
                                    <option value="1">启用</option>
                                </select>
                            </div>
                        </div>
                        <div className="weui-cell weui-cell_select weui-cell_select-after">
                            <div className="weui-cell__hd">
                                <label className="weui-label" htmlFor="charge">计费模式</label>
                            </div>
                            <div className="weui-cell__bd">
                                <select className="weui-select" id="charge" ref={charge => this.charge = charge} onChange={this.onChargeChange}>
                                    <option value="1" selected>计时</option>
                                    <option value="2">计量</option>
                                </select>
                            </div>
                        </div>
                        <div className="weui-cell" ref={form => this.chargeForm1 = form}>
                            <div className="weui-cell__hd"><label className="weui-label" htmlFor="expired">到期时间</label></div>
                            <div className="weui-cell__bd">
                                <input id="expired" ref={expired => this.expired = expired} className="weui-input" type="date" />
                            </div>
                        </div>
                        <div className="weui-cell" ref={form => this.chargeForm2 = form} style={{ display: 'none' }}>
                            <div className="weui-cell__hd"><label className="weui-label" htmlFor="remain">通知条数</label></div>
                            <div className="weui-cell__bd">
                                <input id="remain" ref={remain => this.remain = remain} className="weui-input" type="number" pattern="[0-9]*" placeholder="请输入通知条数" />
                            </div>
                            <div className="weui-cell__ft" style={{ fontSize: '17px' }}>条</div>
                        </div>
                        <div className="weui-btn-area">
                            <input className="weui-btn weui-btn_primary" type="submit" value="修改" />
                            <input className="weui-btn weui-btn_warn" type="button" value="删除" onClick={this.remove} />
                            <input className="weui-btn weui-btn_plain-default" type="button" value="返回" onClick={this.back} />
                        </div>
                    </div>
                </form>
                <div ref={toast => this.toast = toast}>
                    <div className="weui-mask_transparent"></div>
                    <div className="weui-toast">
                        <i className="weui-loading weui-icon_toast"></i>
                        <p className="weui-toast__content">数据加载中</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/edit.js